import { render, staticRenderFns } from "./edit-consommable.html?vue&type=template&id=630a7aff&scoped=true&external"
import script from "./edit-consommable.js?vue&type=script&lang=js&external"
export * from "./edit-consommable.js?vue&type=script&lang=js&external"
import style0 from "./edit-consommable.scss?vue&type=style&index=0&id=630a7aff&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a7aff",
  null
  
)

export default component.exports